import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-02f380c2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "row"
};
const _hoisted_4 = {
  class: "sidebar"
};
const _hoisted_5 = {
  class: "sidebar-menu"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("Профиль ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("Мои подборки ");

const _hoisted_8 = {
  key: 0,
  class: "content"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode("создать новую подборку ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("ul", _hoisted_5, [_createElementVNode("li", {
    class: _normalizeClass({
      'active': _ctx.$route.name === 'info'
    })
  }, [_createVNode(_component_router_link, {
    to: {
      name: 'profile/info'
    },
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.switchTab('profile'))
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  })], 2), _createElementVNode("li", {
    class: _normalizeClass({
      'active': ['profile/compilations', 'profile/compilation-create', 'profile/compilation-update', 'profile/compilation'].indexOf(_ctx.$route.name) !== -1
    })
  }, [_createVNode(_component_router_link, {
    to: {
      name: 'profile/compilations'
    },
    append: "",
    style: {
      "cursor": "pointer"
    }
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  })], 2), _createElementVNode("li", null, [_createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[1] || (_cache[1] = (...args) => $options.logout && $options.logout(...args))
  }, "Выйти")])])]), _ctx.$route.name === 'profile/compilations' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_router_link, {
    to: {
      name: 'profile/compilation-create'
    },
    append: "",
    class: "button2"
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  })])) : _createCommentVNode("", true), ['profile/info', 'profile/compilation-create', 'profile/compilation-update', 'profile/compilation'].indexOf(_ctx.$route.name) !== -1 ? (_openBlock(), _createBlock(_component_router_view, {
    key: 1
  })) : _createCommentVNode("", true)]), _ctx.$route.name === 'profile/compilations' ? (_openBlock(), _createBlock(_component_router_view, {
    key: 0
  })) : _createCommentVNode("", true)])]);
}